/*
Author: Chathuraka Mallawa Arachchi
Date: 18/10/2024
Copyright © 2024 Infix!. All rights reserved.

Responsible for form applying validations based on question type
*/

import { IsmokingTypeValue } from '../types/commonTypes'
import { INode } from '../types/nodeTypes'

const smokingTypes = (function () {
    // const applyValuesToFormObject = (form :FormState, questionnaireDetails, answer )=>{

    //     const validatedForm = ValidationManager.applyCommonValidations(element)
    // }
    const generateSmokingType = (answer: IsmokingTypeValue) => {
        const nodes: INode[] = []
        const perDay: INode = {
            title: 'Per Day',
            type: 'number',
            parent: 'smokingType',
            prevNode: '',
            nextNode: ``, //leave empty until next node fill value
            validations: [
                {
                    type: 'required',
                    message: 'Please select an option',
                },
            ],
            name: `HealthImprovement${answer.type}perDay`,
            value: answer.perDay,
        }

        const years: INode = {
            title: 'Years',
            type: 'number',
            prevNode: '',
            parent: 'smokingType',
            nextNode: '',
            validations: [
                {
                    type: 'required',
                    message: 'Please select an option',
                },
            ],
            name: `HealthImprovement${answer.type}years`,
            value: answer.years,
        }

        nodes.push(perDay)
        nodes.push(years)
        return nodes
    }

    return {
        // applyValuesToFormObject,
        generateSmokingType,
    }
})()

export default smokingTypes
